// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "794d5fd1925b94cdf6a3" + ".digested.js";
};